import { ImgHTMLAttributes, useState } from 'react';

interface ResponsiveImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet'> {
  src: string;
  webpSrc?: string;
  alt: string;
  sizes?: string;
  priority?: boolean;
}

const ResponsiveImage = ({ 
  src, 
  webpSrc, 
  alt, 
  className = '', 
  sizes = '(max-width: 768px) 64px, 80px',
  priority = false,
  ...props 
}: ResponsiveImageProps) => {
  const [loaded, setLoaded] = useState(false);

  const handleLoad = () => {
    setLoaded(true);
  };

  return (
    <picture className="responsive-image">
      {webpSrc && (
        <source
          srcSet={webpSrc}
          type="image/webp"
          sizes={sizes}
        />
      )}
      <img
        src={webpSrc || src} // Prefer WebP if available
        alt={alt}
        className={`${className} ${loaded ? 'loaded' : ''}`}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        onLoad={handleLoad}
        {...props}
      />
    </picture>
  );
};

export default ResponsiveImage;